import type { PersistedStorageAdapterFactory } from './storageAdapter';

let persistedStorageAdapterFactory: PersistedStorageAdapterFactory | null = null;

/**
 * Register a factory for resolving a storage adapter.
 *
 * This is a module-level singleton so hosts can register once during bootstrap.
 * The factory indirection avoids capturing request-specific state at module init time.
 */
export function registerSearchClientStorageAdapterFactory(
	factory: PersistedStorageAdapterFactory | null,
) {
	persistedStorageAdapterFactory = factory;
}

export function getSearchClientStorageAdapterFactory(): PersistedStorageAdapterFactory | null {
	return persistedStorageAdapterFactory;
}
